// @flow

import * as React from 'react';
import styled from 'styled-components';
import { colors, fontWeight } from 'seedling/constants';
import { XIcon } from 'seedling/icons';

const FLAVOR_TO_STYLES = {
  warning: {
    backgroundColor: colors.canaryYellow,
    borderColor: colors.darkYellow,
  },
  error: {
    backgroundColor: colors.almostVeryLightRed,
    borderColor: colors.darkRed,
  },
  success: {
    backgroundColor: colors.budgieGreen,
    borderColor: colors.mediumGreenhouseGreen,
  },
  neutral: {
    backgroundColor: colors.babyBlue,
    borderColor: colors.darkBlue,
  },
};

type Props = {
  title?: string,
  children: React.Node,
  icon?: string,
  flavor: 'warning' | 'error' | 'success' | 'neutral',
  rightComponent?: React.Node,
  onDismiss?: () => void,
};

function Callout(props: Props) {
  return (
    <Container flavor={props.flavor}>
      {props.icon && (
        <IconContainer>
          <props.icon
            color={FLAVOR_TO_STYLES[props.flavor].borderColor}
            width={20}
            height={20}
          />
        </IconContainer>
      )}

      <MainContent>
        {props.title && <Title>{props.title}</Title>}

        <Body>{props.children}</Body>
      </MainContent>

      {props.rightComponent && (
        <RightComponent>{props.rightComponent}</RightComponent>
      )}
      {props.onDismiss && <StyledXIcon onClick={props.onDismiss} />}
    </Container>
  );
}

export default Callout;

const Container = styled.div`
  background-color: ${props => FLAVOR_TO_STYLES[props.flavor].backgroundColor};
  border: solid 1px ${props => FLAVOR_TO_STYLES[props.flavor].borderColor};
  padding: 15px 25px;
  font-size: 14px;
  border-radius: 2px;
  margin-bottom: 15px;
  display: flex;
  align-items: top;
`;

const MainContent = styled.div`
  flex: 1;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: ${fontWeight.heavy};
`;

const Body = styled.div`
  color: ${colors.darkestGrey};
  font-weight: normal;
`;

const IconContainer = styled.div`
  margin-right: 8px;
  height: 20px;
`;

const RightComponent = styled.div`
  margin-left: 24px;
  align-self: center;
`;

const StyledXIcon = styled(XIcon)`
  margin-left: 16px;
`;
